/* eslint-disable no-shadow */
import clsx from 'clsx';

import Link, { LinkProps } from '@mui/material/Link';

import useStyles from './styles';

export enum VariantTypeColorEnum {
  default = 'default',
  blue = 'blue',
  red = 'red',
}

type VariantTypeColor = 'default' | 'blue' | 'red';

interface Props extends LinkProps {
  onClick: () => void;
  isDisabled?: boolean;
  variantColor?: VariantTypeColor;
  children: React.ReactNode;
  boldText?: boolean;
}

function ButtonLink({
  isDisabled = false,
  onClick,
  variantColor = VariantTypeColorEnum.default,
  children,
  boldText,
  ...props
}: Props) {
  const classes = useStyles();

  function handleOnClick() {
    if (!isDisabled) onClick();
  }
  return (
    <Link
      className={clsx(classes.linkBase, {
        [classes[variantColor]]: !isDisabled,
        [classes.linkDisabled]: isDisabled,
        [classes.boldText]: boldText,
      })}
      onClick={handleOnClick}
      {...props}
    >
      {children}
    </Link>
  );
}

export default ButtonLink;
